import './assets/main.css'

import { createApp } from 'vue'
import { createPinia, Store } from 'pinia'

import App from './App.vue'
import initRouter from './pages/router'
import { useModules } from '@commons/plugins/modules'
import { useAdminStore } from '@getmayday/vue-modules'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import draggable from 'vuedraggable'
import { EditorPlugin } from '@getmayday/mayday-editor-vue3'
import { FlowChartPlugin } from '@getmayday/mayday-flow-chart-vue3'
import { useModuleLibrary } from '@getmayday/vue-modules/library'

import '@getmayday/mayday-editor-vue3/mayday-editor.css'
import '@getmayday/mayday-flow-chart-vue3/flow-chart.css'
import '@commons/assets/css/transitions.css'
import { useIadvizeStore } from './plugins/iadvize'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const logs = async (payload: AppLogPayload): Promise<void> => {
  const adminStore = useAdminStore(pinia)
  const { loggedIn } = storeToRefs(adminStore)
  if (!loggedIn.value) return

  return logClient.send(payload)
}

app.use(pinia)

const clients = prepareClients(pinia, 'IADVIZE_APP')
const { logClient, adminClient } = clients
pinia.use(({ store }: { store: Store }): void => {
  if (store.$id === 'helpdesk') store = useIadvizeStore(store as any, adminClient) as any
  if (store.$id !== 'config') return
  store.$logs = logs
  store.$state = { ...store.$state, forceMainFrame: true, hostApp: 'iadvize' }
})

const router = initRouter()

const i18n = initI18n()

const { notify } = useNotification()
const appFunctions = {
  logs,
  notify
}

useModules(app, pinia, i18n, clients, appFunctions, 'iadvize')
useLibrary(app)
useModuleLibrary(app)

app.use(router)
app.use(i18n)
app.use(EditorPlugin, {
  i18n
})
app.use(FlowChartPlugin, {
  i18n
})

app.component('draggable', draggable)
app.directive('click-outside', vClickOutside)
app.directive('stop-propagation', vStopPropagation)

app.provide('logs', logs)
app.provide('notify', notify)
app.provide('pinia', pinia)

app.mount('#app')
